// extracted by mini-css-extract-plugin
export default {"button":"Rk-z","reviewSort":"Sk-z"};